export const TEMPLATE_SHAPE_LAYER_ID = 'template-shape';
export const TEMPLATE_MAIN_TEXT_LAYER_ID = 'template-main-text';
export const TEMPLATE_SUB_TEXT_LAYER_ID = 'template-sub-text';
export const PRIMITIVE_LAYER_PREFIX = 'primitive:';

export const primitiveLayerId = (shapeId) => `${PRIMITIVE_LAYER_PREFIX}${shapeId}`;
export const isPrimitiveLayerId = (layerId) => (
  typeof layerId === 'string' && layerId.startsWith(PRIMITIVE_LAYER_PREFIX)
);
export const layerIdToPrimitiveId = (layerId) => (
  isPrimitiveLayerId(layerId) ? layerId.slice(PRIMITIVE_LAYER_PREFIX.length) : null
);

export const getPrimitiveLayerIds = (shapePrimitives) => (
  Array.isArray(shapePrimitives)
    ? shapePrimitives
      .map((shape, index) => {
        const shapeId = typeof shape?.id === 'string' && shape.id.trim()
          ? shape.id.trim()
          : `shape-${index}`;
        return primitiveLayerId(shapeId);
      })
    : []
);

export const getDefaultPresetLayerOrder = (shapePrimitives) => ([
  TEMPLATE_SHAPE_LAYER_ID,
  ...getPrimitiveLayerIds(shapePrimitives),
  TEMPLATE_MAIN_TEXT_LAYER_ID,
  TEMPLATE_SUB_TEXT_LAYER_ID,
]);

export const normalizePresetLayerOrder = (layerOrder, shapePrimitives) => {
  const defaultOrder = getDefaultPresetLayerOrder(shapePrimitives);
  const allowed = new Set(defaultOrder);
  const normalized = [];

  if (Array.isArray(layerOrder)) {
    for (const layerId of layerOrder) {
      if (typeof layerId !== 'string') continue;
      if (!allowed.has(layerId)) continue;
      if (!normalized.includes(layerId)) normalized.push(layerId);
    }
  }

  for (const fallbackLayerId of defaultOrder) {
    if (!normalized.includes(fallbackLayerId)) normalized.push(fallbackLayerId);
  }

  return normalized;
};

export const normalizePresetLayerLocks = (layerLocks, shapePrimitives) => {
  const validLayerIds = new Set(getDefaultPresetLayerOrder(shapePrimitives));
  if (!layerLocks || typeof layerLocks !== 'object') return {};

  const next = {};
  for (const [layerId, isLocked] of Object.entries(layerLocks)) {
    if (!validLayerIds.has(layerId)) continue;
    if (isLocked === true) next[layerId] = true;
  }
  return next;
};

export const getPresetLayerPanelOrder = (layerOrder, shapePrimitives) => (
  [...normalizePresetLayerOrder(layerOrder, shapePrimitives)].reverse()
);

export const panelOrderToRenderOrder = (panelOrder, shapePrimitives) => (
  normalizePresetLayerOrder([...(Array.isArray(panelOrder) ? panelOrder : [])].reverse(), shapePrimitives)
);

export const moveArrayItem = (list, fromIndex, toIndex) => {
  if (!Array.isArray(list)) return [];
  if (fromIndex === toIndex) return [...list];
  if (fromIndex < 0 || fromIndex >= list.length) return [...list];
  if (toIndex < 0 || toIndex >= list.length) return [...list];
  const next = [...list];
  const [item] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, item);
  return next;
};

export const reorderLayerOrderByPanelIndices = ({
  layerOrder,
  shapePrimitives,
  fromPanelIndex,
  toPanelIndex,
}) => {
  const panelOrder = getPresetLayerPanelOrder(layerOrder, shapePrimitives);
  const movedPanelOrder = moveArrayItem(panelOrder, fromPanelIndex, toPanelIndex);
  return panelOrderToRenderOrder(movedPanelOrder, shapePrimitives);
};

export const duplicatePrimitiveLayerId = (shapeId) => primitiveLayerId(shapeId);

